export const redirectInBrowser = (url: string) => {
  // @todo remove from utils, we shouldn't have any browser specific code here
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  chrome.tabs.create({
    url: url,
  });
};
